var parameterInsert={ 
    IdDocCategory:'', 
    Name:'',  
    Active:'1',
    User:'',
    IP:''
} 
var parameterUpdate={
    IdDocQuestionsCategory:'',
    IdDocCategory:0, 
    Name:'',  
    Active:'1',
    User:'',
    IP:''
} 
var parameterView={ 
    IdEnterprise:'',
    Name:'',  
    Category:'',
    Active:'2'
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}